import { SHORTCUT_PREFIX } from './KeyboardShortcutsPanel.constants';

export const getGeneralShortcuts = () => [
  { key: `${SHORTCUT_PREFIX}K`, label: 'Open search palette' },
  { key: `${SHORTCUT_PREFIX}?`, label: 'Show keyboard shortcuts' },
  { key: 'Esc', label: 'Close panel' },
];
